class AlertForm
  constructor: ->
    $('.inline.intervals input[type=radio]').on 'change', @onAlertFrequencyChange
    $('input[name="search_alert[inactivity]"]').on 'change', @onAlertInactivityChange
    $('.js-clone-search-alert').on 'change', @onCloneAlertChange
    $('.js-test-search-alert').on 'click', @onTestAlertClick

    @updateNextAlertTime()

  emptyInputs: (container) ->
    inputs = document.querySelector(container)?.querySelectorAll('input')

    _.filter inputs, (el) -> el.value is ''

  highlightEmptyInputs: (container) ->
    inputs = @emptyInputs(container)

    return unless inputs.length

    for input in inputs
      input.classList.add('highlight')

      input.addEventListener 'blur', (e) ->
        e.target.classList.remove('highlight')

    inputs[0].focus()

  updateNextAlertTime: ->
    intervalId = $('.inline.intervals input[type=radio]:checked').val()
    $('.next-alert-time').addClass('is-hidden')
    $(".search-interval-#{intervalId}").removeClass('is-hidden')

  ## Event Handlers

  onAlertFrequencyChange: (e) =>
    @updateNextAlertTime()

  onAlertInactivityChange: (e) ->
    isInactivityAlert = (e.target.value == 'true')

    $('input[name="search_alert[minimum]"]').prop('disabled', isInactivityAlert)
    $('input[name="search_alert[minimum]"]').focus() if !isInactivityAlert

  onCloneAlertChange: (e) =>
    return if e.target.value == ''

    settings = JSON.parse(e.target.value)

    for setting of settings
      input = document.getElementById('search_alert_settings_' + setting)

      if input
        input.classList.remove('highlight')
        input.value = settings[setting]

    @highlightEmptyInputs('.js-clone-area')

  onTestAlertClick: (e) ->
    e.preventDefault()

    button = $(this)
    test = button.closest('.SearchAlert-test')
    testStatus = test.find('.SearchAlert-test-status-complete')

    return if test.is('.SearchAlert-test--running')

    test
      .removeClass('SearchAlert-test--complete SearchAlert-test--success SearchAlert-test--failure')
      .addClass('SearchAlert-test--running')

    complete = (message, status) ->
      testStatus.text(message)
      test
        .removeClass('SearchAlert-test--running')
        .addClass("SearchAlert-test--complete SearchAlert-test--#{status}")

    $.ajax
      url: button.attr('href'),
      type: 'POST',
      data: { name: button.data('name') },
      dataType: 'json',
      success: (data) -> complete(data.message, data.status),
      error: -> complete('Error submitting test alert', 'failure')

$ ->
  new AlertForm()
